import { apiCall } from './gqlClient';
const GETANALYTICS_QUERY = "\n  query getAnalytics {\n    getAnalytics\n    {\n      providersAll\n\t\t\tusersAll\n\t\t\tordersAll\n\t\t\tusers\n\t\t\tproviders\n\t\t\torders\n      ...fragments\n    }\n  }";
export const getAnalyticsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETANALYTICS_QUERY,
    variables: {},
    fragments
  });
};